import Vue from 'vue'

import Divider from '@/components/line/Divider'
import Breadcrumb from '@/components/system/Breadcrumb'
import PairSpin from '@/components/system/PairSpin'
import MomaPage from '@/components/MomaPage'
import ConfProjectStep from '@/components/proj/ConfProjectStep'
import FeeSumCard from '@/components/proj/FeeSumCard'
import FundStatSumCard from '@/components/proj/FundStatSumCard'
import PaymentSumCard from '@/components/proj/PaymentSumCard'
import CashierFlowEntityCard from '@/components/proj/CashierFlowEntityCard'
import SettleInvoiceListCard from '@/components/proj/SettleInvoiceListCard'
import FeeSettleTransListCard from '@/components/proj/FeeSettleTransListCard'
import DataAuditCard from '@/components/audit/DataAuditCard'
import RecordHistDataAuditCard from '@/components/audit/RecordHistDataAuditCard'
import SysLogSqlCard from '@/components/audit/SysLogSqlCard'
import ProjMthRptCard from '@/components/proj/ProjMthRptCard'

Vue.component('Divider', Divider)
Vue.component('PairBreadcrumb', Breadcrumb)
Vue.component('PairSpin', PairSpin)
Vue.component('MomaPage', MomaPage)
Vue.component('ConfProjectStep', ConfProjectStep)
Vue.component('FeeSumCard', FeeSumCard)
Vue.component('FundStatSumCard', FundStatSumCard)
Vue.component('PaymentSumCard', PaymentSumCard)
Vue.component('CashierFlowEntityCard', CashierFlowEntityCard)
Vue.component('SettleInvoiceListCard', SettleInvoiceListCard)
Vue.component('FeeSettleTransListCard', FeeSettleTransListCard)
Vue.component('DataAuditCard', DataAuditCard)
Vue.component('RecordHistDataAuditCard', RecordHistDataAuditCard)
Vue.component('SysLogSqlCard', SysLogSqlCard)
Vue.component('ProjMthRptCard', ProjMthRptCard)



// WEBPACK FOOTER //
// ./src/custom/index.js